import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class MerchantCleanUpService {
  private BASE_URL = 'oc-api/operations/support/merchant-clean-up/'

  constructor(private http: HttpClient) {
  }

  deleteCustomers(merchantId: number, type: string): Observable<any> {
    const params = new HttpParams().set('type', type);
    return this.http.delete(this.BASE_URL + merchantId + '/customers', {params});
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/merchant-clean-up/merchant-clean-up.service.ts